import React, { useRef } from 'react';
import { Input, SearchIcon, colors, XIcon } from '@commonsku/styles';
import styled from 'styled-components';
import { SearchBoxInputProps } from './types';

const StyledLabeledInput = styled(Input)`
  &&& {
      ::placeholder {
        color: ${colors.primary1['65']};
      }
      :focus::placeholder {
        color: ${colors.primary1['65']};
      }
  }
`;

const SearchBoxInput: React.FC<SearchBoxInputProps> = ({
  value,
  onChange,
  isSearchStalled,
  placeholder = 'Search the Connected+ Suppliers database',
  autoFocus = true,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div>
      <form
        action=""
        role="search"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (inputRef.current) {
            inputRef.current.blur();
          }
        }}
        onReset={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onChange('');
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }}
      >
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
            {0 === value.length || isSearchStalled
              ? <SearchIcon size='huge' />
              : <XIcon size='huge' color={colors.errors['60']} pointer onClick={() => onChange('')} />
            }
          </div>
          <StyledLabeledInput
            ref={inputRef}
            style={{
              fontSize: 18,
              padding: '16px 80px 16px 32px',
              height: 78,
              borderRadius: 10,
              border: `2px solid ${colors.primary1['65']}`,
            }}
            placeholder={placeholder}
            value={value}
            type="search"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              onChange(event.currentTarget.value);
            }}
            autoFocus={autoFocus}
          />
        </div>
      </form>
    </div>
  );
};

export default SearchBoxInput;
